import { pickT } from "@repo/shared";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MarkdownEditor } from "@/components/ui/markdown-editor";
import { T } from "./modal-editor.i18n";

type ModalEditorProps = {
  buttonLabel: string;
  title: string;
  content: string;
  flowLanguage: string;
  onButtonLabelChange: (value: string) => void;
  onTitleChange: (value: string) => void;
  onContentChange: (value: string) => void;
};

export function ModalEditor({
  buttonLabel,
  title,
  content,
  flowLanguage,
  onButtonLabelChange,
  onTitleChange,
  onContentChange,
}: ModalEditorProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="modal-button-label">
          {t.buttonLabel} <span className="text-destructive">*</span>
        </Label>
        <Input
          id="modal-button-label"
          value={buttonLabel}
          onChange={(e) => onButtonLabelChange(e.target.value)}
          placeholder={t.buttonLabelPlaceholder}
        />
        <p className="text-xs text-muted-foreground">{t.buttonLabelHint}</p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="modal-title">
          {t.title} <span className="text-destructive">*</span>
        </Label>
        <Input
          id="modal-title"
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          placeholder={t.titlePlaceholder}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="modal-content">
          {t.content} <span className="text-destructive">*</span>
        </Label>
        <MarkdownEditor
          value={content}
          onChange={onContentChange}
          placeholder={t.contentPlaceholder}
          showAI={false}
          // QL-296 — the popup shares FlowMarkdown with the text block, which
          // draws every heading as the one flow component header, so offer one.
          headings="single"
        />
        <p className="text-xs text-muted-foreground">{t.contentHint}</p>
      </div>
    </div>
  );
}
